globalThis.appCustomerSpace = globalThis.appCustomerSpace || {};
appCustomerSpace.Modules = appCustomerSpace.Modules || {};

appCustomerSpace.Modules.InputCharactersCount = (function() {

    function InputCharactersCount($input) {
        this.$input = $input;
        this.$formGroup = this.$input.closest('.form-group');
        this.ensureCounterMarkup();
        this.init();
    }

    InputCharactersCount.init = function($html) {
        $html.find('.count-characters').each(function(){
            new InputCharactersCount($(this));
        })
    }

    InputCharactersCount.prototype = {
        ensureCounterMarkup: function() {
            if (!this.$formGroup.length) {
                return;
            }

            var $existingWrapper = this.$formGroup.find('.input-characters-count-wrapper');
            if ($existingWrapper.length) {
                return;
            }

            var max = this.$input.data('max-characters-count');
            var min = this.$input.data('min-characters-count');

            var counterHtml = '<span class="text-muted mt-5 input-characters-count-wrapper" style="display: block; text-align: right;">'
                + '<span class="input-characters-count"' + (min !== undefined ? (' data-min-characters-count="' + min + '"') : '') + '>0</span>';

            if (max !== undefined) {
                counterHtml += '/<span class="max-characters-count">' + max + '</span>';
            }

            counterHtml += ' caractères</span>';

            var $counter = $(counterHtml);
            this.$input.after($counter);
        },
        init: function() {
            var _this = this;

            _this.$input.on('input', function() {
                _this.refresh();
            });

            _this.refresh();
        },
        charactersCount: function() {
            var value = this.$input.val() || '';

            return value.replace(/[\r\n]/g, '').length;
        },
        refresh: function() {
            var $inputCharactersCount = this.$formGroup.find('.input-characters-count');

            if (!$inputCharactersCount.length) {
                return;
            }

            var count = this.charactersCount();
            $inputCharactersCount.text(count);

            var max = this.$input.data('max-characters-count');
            var min = this.$input.data('min-characters-count');

            var isTooLong = (max !== undefined) ? (count > max) : false;
            var isTooShort = (min !== undefined) ? (count < min) : false;
            var isInvalid = isTooLong || isTooShort;

            this.$formGroup.find('.input-characters-count-wrapper').toggleClass('text-danger', isInvalid);
        }
    }

    return InputCharactersCount;

})();
